import SIcon from './icon';
import SButton from './button';
import SPopup from './popup';
import SModalInstall, { SModal } from './modal';
import SNotice from './notice';
import './style/index.less';

const components = [SIcon, SButton, SPopup, SModal];

const install = Vue => {
  components.forEach(component => Vue.component(component.name, component));
  Vue.use(SModalInstall);
  Vue.use(SNotice);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export { SIcon, SButton, SPopup, SModal };

export default { install, SIcon, SButton, SPopup, SModal };
